<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12">
      <p-accordion [multiple]="false" (onOpen)="abrirAcordeon($event)">
        <p-accordionTab header="{{ 'REQUISITOS.LBL_INFOGENERAL' | translate}}" [selected]="tabSeleccionado === 'INFO'">
          <form [formGroup]="formulario">
            <div class="grid form-group">
              <div class="col-12 md:col-4 lg:col-4">
                <div class="div-form">
                  <label>* {{ 'REQUISITOS.LBL_CODIGOIDENTIFICACION' | translate }}</label>
                  <div *ngIf="!requisito">
                    <input type="text" pInputText id="idcodigo"
                           name="nomcodigo"
                           autocomplete="off"
                           (blur)="validarCodigo()"
                           formControlName="codigo" codigos-reactive
                           [maxlength]="10">
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigo.invalid">
                      {{ 'REQUISITOS.LBL_CODIGOIDENTIFICACION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                    <div class="p-message p-messages-error p-corner-all"
                         *ngIf="codExiste">
                      {{ 'MSG_CODIGOEXISTE' | translate}}
                    </div>
                  </div>
                  <label class="falso-combo-texto" *ngIf="f.idRequisitoGarantia.value">{{f.codigo.value}}</label>
                </div>
              </div>
              <div class="col-12 md:col-4 lg:col-4">
                <div class="div-form">
                  <label>* {{'REQUISITOS.LBL_NOMBRE' | translate}}:</label>
                  <input type="text" pInputText id="nombre"
                         name="nomNombre"
                         autocomplete="off"
                         formControlName="nombre"
                         capitalize-reactive
                         [maxLength]="50"
                  >
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombre.invalid">
                    {{ 'REQUISITOS.LBL_NOMBRE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-4 lg:col-4">
                <div class="div-form">
                  <label>* {{ 'REQUISITOS.LBL_MONTOMAXIMOHASTA' | translate }}</label>
                  <input type="text" pInputText id="idmontoMaximo"
                         name="nommontoMaximo"
                         autocomplete="off"
                         formControlName="montoMaximo" numero-decimal-reactive
                         [decimales]="6" [entero]="7">
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.montoMaximo.invalid">
                    {{ 'REQUISITOS.LBL_MONTOMAXIMOHASTA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
            </div>
            <div class="grid form-group">
              <div class="col-12 md:col-4 lg:col-4">
                <div class="div-form">
                  <label>* {{ 'REQUISITOS.LBL_GARANTIAS' | translate }}(%)</label>
                  <input type="text" pInputText id="idGarantia"
                         name="nomGarantia"
                         autocomplete="off"
                         formControlName="garantia" numero-decimal-reactive
                         [decimales]="6" [entero]="3">
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.garantia.invalid">
                    {{ 'REQUISITOS.LBL_GARANTIAS' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
            </div>
            <div class="grid">
              <div class="col-12 md:col-12 lg:col-12">
                <h3 class="titulo-pagina">{{ 'REQUISITOS.LBL_MODALIDAD' | translate}}</h3>
              </div>
            </div>

            <form [formGroup]="formModalidad" novalidate>
              <div class="grid form-group">
                <div class="col-12 md:col-8 lg:col-8">
                  <div class="div-form">
                    <label>* {{ 'REQUISITOS.LBL_MODALIDAD' | translate }}</label>
                    <p-multiSelect id="idModalidad" name="nomModalidad" [options]="lisModalidad"
                                   defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                                   selectedItemsLabel="{0} {{ 'LBL_ELEMENTOSSELECCIONADOS' | translate}}"
                                   formControlName="items"
                                   emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                   emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                   optionValue="value"
                                   optionLabel="label"
                    ></p-multiSelect>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="subModalidad && fTablas(codModalidad).items.invalid">
                      {{ 'REQUISITOS.LBL_MODALIDAD' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                </div>
                <div class="col-12 md:col-4 lg:col-4 pt-5">
                  <button class="p-button-datatables" icon="fa fa-plus" label="{{'BTN_AGREGAR' | translate }}"
                          type="button" (click)="agregarTabla(codModalidad)"
                          pButton></button>
                </div>
              </div>
            </form>
            <div>
              <div class="grid">
                <div class="col-12 md:col-6 lg:col-6">
                </div>
                <div class="col-12 md:col-6 lg:col-6">
                  <input type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
                         (input)="dt.filterGlobal($event.target.value, 'contains')">
                </div>
              </div>

              <div class="grid">
                <div class="col-12 md:col-12 lg:col-12">
                  <p-table [columns]="colModalidad" #dt
                           [value]="lisRequisitoModalidad"
                           [paginator]="true" [rows]="rows"  paginatorPosition="bottom">
                    <ng-template pTemplate="header" let-columns>
                      <tr>
                        <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                          {{col.header}}
                          <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                        </th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-row>
                      <tr [pSelectableRow]="row">
                        <td>{{row.modalidad}}</td>
                        <td class="text-center">
                          <div class="btn-group" role="group">
                            <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                                    title="{{'BTN_INHABILITAR' | translate}}" pButton
                                    (click)="inhabilitarTabla(row, codModalidad)"></button>
                          </div>
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                      <tr>
                        <td [attr.colspan]="columns.length">
                          {{ 'MSG_NOHAYREGISTROS' | translate}}
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>

            <div class="grid">
              <div class="col-12 md:col-12 lg:col-12">
                <h3 class="titulo-pagina">{{ 'REQUISITOS.LBL_TIPORESPARDO' | translate}}</h3>
              </div>
            </div>

            <form [formGroup]="formTipoRespaldo" novalidate>
              <div class="grid form-group">
                <div class="col-12 md:col-8 lg:col-8">
                  <div class="div-form">
                    <label>{{ 'REQUISITOS.LBL_TIPORESPARDO' | translate }}</label>
                    <p-multiSelect id="idRequisito" name="nomRequisito" [options]="lisTipoRespaldo"
                                   defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                                   selectedItemsLabel="{0} {{ 'LBL_ELEMENTOSSELECCIONADOS' | translate}}"
                                   formControlName="items"
                                   emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                   emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                   optionLabel="label"
                                   optionValue="value"
                    ></p-multiSelect>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="subTipoRespaldo && fTablas(codRespaldo).items.invalid">
                      {{ 'REQUISITOS.LBL_TIPORESPARDO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                </div>
                <div class="col-12 md:col-4 lg:col-4 pt-5">
                  <button class="p-button-datatables" icon="fa fa-plus" label="{{'BTN_AGREGAR' | translate }}"
                          type="button" (click)="agregarTabla(codRespaldo)"
                          pButton></button>
                </div>
              </div>
            </form>
            <div>
              <div class="grid">
                <div class="col-12 md:col-6 lg:col-6">
                </div>
                <div class="col-12 md:col-6 lg:col-6">
                  <input type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
                         (input)="dt2.filterGlobal($event.target.value, 'contains')">
                </div>
              </div>

              <div class="grid">
                <div class="col-12 md:col-12 lg:col-12">
                  <p-table [columns]="colTipoRespaldo" #dt2
                           [value]="lisRequisitoTipoRespaldo"
                           [paginator]="true" [rows]="rows"  paginatorPosition="bottom">
                    <ng-template pTemplate="header" let-columns>
                      <tr>
                        <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                          {{col.header}}
                          <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                        </th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-row>
                      <tr [pSelectableRow]="row">
                        <td>{{row.tipoRespaldo}}</td>
                        <td class="text-center">
                          <div class="btn-group" role="group">
                            <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                                    title="{{'BTN_INHABILITAR' | translate}}" pButton
                                    (click)="inhabilitarTabla(row, codRespaldo)"></button>
                          </div>
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                      <tr>
                        <td [attr.colspan]="columns.length">
                          {{ 'MSG_NOHAYREGISTROS' | translate}}
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>


            <div class="grid form-group">
              <div class="col-12 md:col-6 lg:col-6">
                <p-checkbox label="{{ 'REQUISITOS.LBL_UNIDADCREDITO' | translate}}" binary="true"
                            id="indicadorUnidadCredito"
                            name="nomIndicadorUnidadCredito"
                            formControlName="indicadorUnidadCredito"></p-checkbox>
              </div>
              <div class="col-12 md:col-6 lg:col-6">
                <p-checkbox label="{{ 'REQUISITOS.LBL_REQUIEREGARANTIA' | translate}}" binary="true"
                            id="indicadorRequiereGarantia"
                            name="nomIndicadorRequiereGarantia"
                            formControlName="indicadorRequiereFondoGarantiaIdonea"></p-checkbox>
              </div>
            </div>


            <div class="grid form-footer-buttons">
              <div class="form-group col-12" *ngIf="!guardando">
                <a (click)="goBack(formulario.dirty)" class="cancelar">{{ 'BTN_CANCELAR' | translate }}</a>
                <button pButton icon="fa fa-plus" label="{{ 'BTN_GUARDAR' | translate}}" type="button" (click)="onSubmit()"></button>
              </div>
              <div class="form-group col-12" *ngIf="guardando">
                <i class="fa fa-refresh fa-spin fa-fw"></i>
                <span>{{ 'LBL_GUARDANDO' | translate}}...</span>
              </div>
            </div>
          </form>
        </p-accordionTab>
        <p-accordionTab header="{{ 'REQUISITOS.LBL_PRODUCTOS' | translate}}" [selected]="tabSeleccionado === 'PRODUCTO'"
                        [disabled]="!requisito">
          <app-requisito-producto [requisito]="requisito" *ngIf="requisito"
                                  (dismiss)="cambiarTabSeleccionado('RESPALDO')"></app-requisito-producto>
        </p-accordionTab>
        <p-accordionTab header="{{ 'REQUISITOS.LBL_REQUISITOS' | translate}}" [selected]="tabSeleccionado === 'RESPALDO'"
                        [disabled]="!requisito">
          <app-requisito-respaldo [requisito]="requisito" *ngIf="requisito" [listasTiposOcupaciones]="listasTiposOcupaciones"
                                  [listaTiposPersonas]="listasTiposPersonas"
                                  (dismiss)="cambiarTabSeleccionado('UNIDADCREDITO')"></app-requisito-respaldo>
        </p-accordionTab>
        <p-accordionTab header="{{ 'REQUISITOS.LBL_UNIDADCREDITO' | translate}}" [selected]="tabSeleccionado === 'UNIDADCREDITO'"
                        *ngIf="requisito && requisito.indicadorUnidadCredito">
          <app-requisito-tipo-vinculacion [requisito]="requisito" *ngIf="requisito"
                                          (dismiss)="cambiarTabSeleccionado('RESPALDO')"></app-requisito-tipo-vinculacion>
        </p-accordionTab>
      </p-accordion>
      <div class="grid form-footer-buttons" *ngIf="requisito">
        <div class="form-group col-12">
          <button pButton icon="fa fa-arrow-left " label="{{ 'BTN_REGRESAR' | translate}}" (click)="regresar()" type="button"></button>
        </div>
      </div>
    </div>
  </div>
</div>
<p-confirmDialog #cd key="requisito">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>

